import { GoogleLogin } from 'react-google-login';
import { parseGoogleResponse } from "../../../utils/index";
import { socialLogin } from "../../../api/auth";
import { RegisterationDone } from "../../../store/actions/registeration";
import { toastr } from 'react-redux-toastr';
import { useDispatch } from "react-redux";
import { AuthSuccess } from "../../../store/actions/auth";
import { useRouter } from 'next/router';

function Google(props) {
	const dispatch = useDispatch();
	const router = useRouter();

	const handleGoogleCallback = (response) => {
		const parsedData = parseGoogleResponse(response);
		if (Object.keys(parsedData).length) {
			socialLogin(parsedData).then((res) => {
				if (Object.keys(res).length > 0) {
					if (res?.is_new_user) {
						dispatch(RegisterationDone({ id: res.user_id, email: parsedData.email, name: parsedData.name, source: 'Facebook', token: res.auth_token, isNewUser: res.is_new_user, authenticated: true }));
						router.push('/register/select-gender', "/select-gender", { shallow: true });
					} else if (res?.user_data) {
						dispatch(AuthSuccess({ user: res.user_data, token: res.auth_token, profile: res.user_data?.profile }));
						router.push('/home', "/home", { shallow: true });
					}
				}
			});
		} else {
			toastr.error('Sorry!', 'Something went wrong with Google Login.');
		}
	}

	const handleGoogleFailureCallback = (err) => {
		// toastr.error('Sorry!', 'Something went wrong with Google Login.');
	}

	return (
		<GoogleLogin
			clientId={process.env.Google_APP_ID}
				buttonText=""
				autoLoad={false}
				onSuccess={handleGoogleCallback}
				onFailure={handleGoogleFailureCallback}
				className="google-button"
			/>
	);
};

export default Google;
